import RefundRequests from "../components/admin/RefundRequests";
import AdminLayout from "../components/layout/AdminLayout";

export default function AdminRefunds() {
  return <RefundRequests canManage={false} Layout={AdminLayout} />;
}
